<template>
    <div class="bg-gray-100">
        <inertia-head v-if="typeof $page !== 'undefined'">
            <link rel="icon" type="image/svg+xml" :href="$page.props.configs.companyLogo"/>
            <meta property="og:locale" content="en_US"/>
            <meta property="og:type" content="article"/>
            <meta property="og:url" content="/"/>
            <meta property="og:site_name" :content="`${$page.props.configs.companyName}`"/>
            <meta property="og:image" :content="`${$page.props.configs.companyLogo}`">
            <meta property="og:image:secure_url" :content="`${$page.props.configs.companyLogo}`">
            <meta property="og:image:width" content="355">
            <meta property="og:image:height" content="347">
            <meta property="og:image:alt" :content="`${$page.props.configs.companyName}`">
            <meta property="og:image:type" content="image/jpeg">
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:creator" :content="`${$page.props.configs.twitterLink}`"/>
            <meta name="twitter:site" :content="`${$page.props.configs.twitterLink}`"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta name="twitter:image" :content="`${$page.props.configs.companyLogo}`">
        </inertia-head>

        <jet-banner/>

        <loading :show="loading"/>

        <Header :navigation_show="navigation_show" :navigation="navigation_show=$event"/>
        <div class="mt-lg-14 mt-md-14 mt-sm-2" @click="navigation_show=false">
            <slot name="main_content"/>
        </div>
        <Footer/>
        <!--        <template >-->
        <!--            -->
        <!--        </template>-->
        <!-- <VueBottomNavigation v-if="$page.props.user" :options="options" :value="1" v-model="selected" >
            <template #icon="{ props }"> <span class="material-icons">{{ props.icon }}</span> </template>
            <template #title="{ props }"> <b>{{ props.title }}</b> </template>
        </VueBottomNavigation> -->
    </div>
</template>

<script>

let JetConfirmationModal;

if (process.browser) {
    JetConfirmationModal = require('@/Jetstream/ConfirmationModal');
}

import Header from "@/Pages/Components/Header";
import Footer from "@/Pages/Components/Footer";

import {Inertia} from "@inertiajs/inertia";
import JetBanner from '@/Jetstream/Banner'
import {InertiaHead} from '@inertiajs/inertia-vue3'
import Loading from "@/Jetstream/Loading";

export default {
    name: "Main",
    components: {Footer, Header, JetConfirmationModal, JetBanner, InertiaHead, Loading},
    data() {
        return {
            navigation_show: false,
            selected: 1,
            options: [
                {
                    id: 1,
                    icon: "home",
                    title: "Home",
                    link: "/"
                },
                {
                    id: 2,
                    icon: "play_lesson",
                    title: " My Course",
                    link: "/dashboard/master/master-request"
                },
                {
                    id: 3,
                    icon: "account_balance_wallet",
                    title: " wallet",
                    link: "/dashboard/account-balance-wallet"
                },
                {
                    id: 4,
                    icon: "perm_identity",
                    title: "Profile",
                    link: this.$page.props?.user?.role==='master' ? '/dashboard/master/courses' : '/dashboard/user/profile',
                },
            ],
            loading: false,
        }
    },
    mounted() {
        Inertia.on('start', event => {
            this.loading = true;
        });

        Inertia.on('finish', event => {
            this.loading = false;
        })
    },
}
</script>

<style scoped>

</style>
